import React, { useEffect, useState, useContext } from "react";
import { View } from "react-native";
import {
  updateWebURL,
  handleSessionCheck,
} from "../accessories/CommonFunctions";
import { Separator, context } from "../accessories/accessories";
import { web } from "../accessories/Platform";
import ScrollContainer from "../accessories/ScrollContainer";
import {
  NavBarContent,
  handleManipulateNavOptions,
  handleProcessNavOptions,
  navOption,
} from "./NavAccessories";

const LeftNavBar = (props) => {
  let {
    isDashBoard = false,
    isHome = false,
    handleLogOut = () => {},
    completedPage = null,
    excludePageIds = [],
    additionalEmploymentList = [],
    pageIndex = { page: 0, subPage: 0 },
    isEsignOnly,
    pageId,
  } = props;

  const { contextDetails, setContextDetails } = useContext(context); //Get value from context
  const { navigation, SessionId = "" } = contextDetails;
  const [currentPage, setCurrentPage] = useState(
    isDashBoard ? "My Dashboard" : props["activePage"] || "Summary Info"
  );
  const [navLeftOptionState, setNavLeftOptionState] = useState(navOption || []);

  useEffect(() => {
    handleSessionCheck(SessionId, handleLogOut);
  }, [SessionId]);
  useEffect(() => {
    setCurrentPage(
      isDashBoard ? "My Dashboard" : props["activePage"] || "Summary Info"
    );
  }, [props]);
  useEffect(() => {
    if (isHome && completedPage) {
      let updatedArray = (navLeftOptionState || navOption).map(
        (item, index) => {
          item["Status"] = completedPage.indexOf(index) > -1 ? 1 : 0;
          return item;
        }
      );

      updatedArray = handleProcessNavOptions(
        updatedArray,
        pageIndex,
        additionalEmploymentList,
        pageId
      );

      setNavLeftOptionState([...[], ...updatedArray]);
    }
    setCurrentPage(
      isDashBoard ? "My Dashboard" : props["activePage"] || "Summary Info"
    );
  }, [completedPage]);

  useEffect(() => {
    setNavLeftOptionState(
      handleManipulateNavOptions(isEsignOnly, excludePageIds)
    );
  }, [excludePageIds, isEsignOnly]);

  let navLeftOption = navLeftOptionState || navOption;
  if (props["loanId"] == -999) {
    navLeftOption[0]["isExpand"] = true;
  }
  if (isDashBoard) navLeftOption = [{ Name: "My Dashboard" }];
  else {
    // if (navLeftOption.length > 0) navLeftOption[0]["active"] = true;
    navLeftOption = [...[{ Name: "My Dashboard" }], ...navLeftOption];
  }

  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    if (path == "DashBoard") {
      option = { ...option, from: "Home", flag: "changeActiveIndex" };
    }
    (navigation || props["navigation"]).navigate(path, option || {});
    setContextDetails((prevContextDetails) => {
      delete prevContextDetails["GoToNav"];
      delete prevContextDetails["loanId"];
      delete prevContextDetails["UserId"];
      prevContextDetails["Path"] = path;
      return { ...prevContextDetails };
    });
  };

  return (
    <>
      <View
        style={[
          {
            width: 350,
            backgroundColor: "#fff",
            paddingHorizontal: 15,
          },
          web ? { position: "fixed", height: "100%" } : {},
        ]}
      >
        <ScrollContainer>
          <NavBarContent
            navigate={navigate}
            navLeftOptionState={navLeftOptionState}
            setNavLeftOptionState={setNavLeftOptionState}
            navLeftOption={navLeftOption}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            {...props}
          />

          <Separator />
          <Separator />
          <Separator />
          <Separator />
          <Separator />
        </ScrollContainer>
      </View>
    </>
  );
};

export default LeftNavBar;
